import React, { useState } from 'react';
import { Button } from '@heroui/react';
import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import CreateGuideModal from './CreateGuideModal';
import { CreateGuideData } from '../types';

interface CreateGuideButtonProps {
  onCreateGuide?: (data: CreateGuideData) => void;
}

const CreateGuideButton: React.FC<CreateGuideButtonProps> = ({ onCreateGuide }) => {
  const { t } = useTranslation('admin');
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const handleOpenCreateModal = () => {
    setIsCreateModalOpen(true);
  };

  const handleCloseCreateModal = () => {
    setIsCreateModalOpen(false);
  };

  return (
    <>
      <Button color="primary" endContent={<Plus className="w-4 h-4" />} onPress={handleOpenCreateModal}>
        {t('guides.createButton')}
      </Button>

      <CreateGuideModal isOpen={isCreateModalOpen} onClose={handleCloseCreateModal} />
    </>
  );
};

export default CreateGuideButton;
